import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './thumbnail.scss';

import Icon, { IconColors, IconSizes } from '../../component/Icons/Icon';
import cn from 'classnames';
import { CDN_BASE_URL } from '../../../../../../../../../.storybook/utils';
import { TRANSLATIONS } from '../../../translations';

const Thumbnail = ({
  file,
  setFiles,
  handleDelete,
  setFileLoadingCounter,
  setError,
}) => {
  const [isUploading, setIsUploading] = useState(true);
  const [uploadError, setUploadError] = useState(null);
  const [responseData, setResponseData] = useState(null);

  useEffect(() => {
    let isMounted = true;

    file.status
      .then((response) => {
        if (isMounted) {
          setResponseData(response.data);
        }
      })
      .catch((error) => {
        if (isMounted) {
          if (error.response && error.response.status === 409) {
            // Duplicate file detected, remove it silently
            setFiles((prev) => prev.filter((f) => f !== file));
          } else {
            setUploadError(error);
            setError(TRANSLATIONS.FILE_GENERIC_ALERT);
          }
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsUploading(false);
          setFileLoadingCounter(prev => Math.max(prev - 1, 0));
        }
      });

    return () => {
      isMounted = false;
    };
  }, [file.status]);

  const isVideoType = () => {
    return file.type.startsWith('video');
  };

  return (
    <div
      className={cn('thumbnail', {
        error: uploadError,
      })}
      style={{
        // In case of video preview it only gets the background color
        background: `url("${file.preview}") lightgray 50% / cover no-repeat`,
      }}
    >
      <div
        className={cn(
          'background--mask absolute z-index-1 w-100% h-100% radius-xs',
          { 'bg-mask-error': uploadError },
          { 'bg-mask-loading': isUploading }
        )}
      />
      {!isUploading && (
        <>
          <div
            className="delete--button"
            onClick={() => {
              handleDelete(responseData);
              setFiles((prev) => prev.filter((f) => f.name !== file.name));
            }}
          >
            <Icon
              name="close"
              size={IconSizes[8]}
              color={uploadError ? IconColors.error : IconColors.regular}
            />
          </div>
          {isVideoType() && (
            <div className="absolute z-index-1">
              <img src={`${CDN_BASE_URL}/icons/thumbnail-video.svg`} />
            </div>
          )}
        </>
      )}
      {isUploading && (
        <div className="absolute z-index-1">
          <Icon
            classNames="animate-spin"
            name="spinner"
            color={IconColors.ghost}
            size={IconSizes[19]}
          />
        </div>
      )}
      {isVideoType() && <video className="w-100% h-100%" src={file.preview} />}
    </div>
  );
};

Thumbnail.propTypes = {
  file: PropTypes.object,
  setFiles: PropTypes.func,
  handleDelete: PropTypes.func,
};

export default Thumbnail;
